import React, { useState, useEffect } from "react";
import { clearPreTickets, deletePreTicket, getFiltredPreTickets } from "../../utils/getPreTickets";
import { QRCodeSVG } from "qrcode.react";

import "../styles/components/preTicketList.scss";
import { Ticket } from "src/rifa/components";
import { R$ } from "../utils/brl";

/**
 * @typedef {import("../../utils/getPreTickets").PreTicket} PreTicket
 */

export default function PreTicketList({ user, GoToPreTicket }) {
    /**
     * @type {[PreTicket[], (value: PreTicket[]) => void]}
     */
    const [list, setList] = useState([]);

    /**
     * @type {[number|null, (value: number|null) => void]}
     */
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        update();
    }, []);

    function update() {
        setList(getFiltredPreTickets());
    }

    /**
     * @param {number} index 
     */
    function select(index) {
        if(GoToPreTicket) GoToPreTicket();
        setSelected(index);
    }

    function close() {
        setSelected(null);
    }

    function clear() {
        if (window.confirm("Tem certeza de quer quer EXCLUIR TODOS os pré-tickets? Essa ação é irreversível!")) {
            clearPreTickets();
            update();
        }
    }

    function remove(selection) {
        deletePreTicket(selection);
        update();
        close();
    }
    
    return list.length > 0 && <div className="preticket-list__wrapper">
            <h2 className="preticket-list__title">Pré-tickets</h2>
            <div className="preticket-list__container">
                {list.map((ticket, index) => 
                    <div key={`preticket-${index}`} 
                        className="preticket-list-item"
                        onClick={() => select(index)}
                    >
                        <div className="preticket-list-item__qrcode">
                            <QRCodeSVG value={ticket.preTicket} />
                        </div>
                        <div className="preticket-list-item__details">
                            <h2 className="preticket-list-item__title">
                                {ticket.tipoJogoCategoria || ticket.bilhetes[0].name}
                            </h2>
                            <p className="preticket-list-item__subtitle">
                                {ticket.bilhetes[0].date.replace(",", "").slice(0, -3)}<br/>
                                {R$(ticket.bilhetes[0].value)}
                            </p>
                        </div>
                    </div>
                )}
                {selected != null && 
                    <Ticket bilhetes={list[selected].bilhetes} onClose={close} preTicket={list[selected].preTicket} onDelete={() => {remove(selected);}}/>
                }
            </div>
        </div>
}


// WEBPACK FOOTER //
// ./src/rifa/components/preTicketList.jsx